import Vue from 'vue';
import InitLayout from '@/layouts/Init.vue';
import AdminLayout from '@/layouts/Admin.vue';
import AuthLayout from '@/layouts/Auth.vue';
import SvgIcon from '@/components/common/SvgIcon.vue';
import SearchInput from '@/components/common/SearchInput.vue';
import Dialog from '@/components/common/Dialog.vue';
import DatePicker from '@/components/common/DatePicker.vue';
import Snackbar from '@/components/common/Snackbar.vue';
import Pagination from '@/components/common/Pagination.vue';
import VendorSelector from '@/components/common/VendorSelector.vue';

Vue.component('init-layout', InitLayout);
Vue.component('admin-layout', AdminLayout);
Vue.component('auth-layout', AuthLayout);
Vue.component('svg-icon', SvgIcon);
Vue.component('search-input', SearchInput);
Vue.component('admin-dialog', Dialog);
Vue.component('date-picker', DatePicker);
Vue.component('snack-bar', Snackbar);
Vue.component('admin-pagination', Pagination);
Vue.component('vendor-selector', VendorSelector);
